module.exports = __webpack_public_path__ + "img/battery_0blue.ab92bd6a.png";